import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Logo from "../../assets/images/logo.png";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// import {
//   _set_token_in_localStorage,
//   _set_user_in_localStorage,
// } from "../local_storage/local_storage";
import { useSnackbar } from "notistack";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { confirm_password_Api } from "../../DAL/adminAuth/auth";

export default function ConfirmPassword() {
  //   const { setUserInfo } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const email = location?.state?.email;

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
    new_password: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputs.password !== inputs.new_password) {
      enqueueSnackbar("New Password and Confirm New Password must match", {
        variant: "error",
      });
      return;
    }

    const confirm_post_data = {
      email: email,
      password: inputs.password,
      confirm_password: inputs.new_password,
    };
    setIsLoading(true);
    const response = await confirm_password_Api(confirm_post_data);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      navigate("/login");
      setIsLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  return (
    <div className="pageContainer">
      <div className="form-container">
        <div className="form-content">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "16px",
              fontWeight: 500,
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            <ArrowBackIcon
              onClick={() => navigate("/")}
              fontSize="small"
              sx={{
                mr: 1,
                backgroundColor: "black",
                color: "white",
                borderRadius: "50%", // makes it circular
                padding: "6px", // adjust to balance the circle
                fontSize: "31px", // increased icon size
                cursor: "pointer",
              }}
            />
            Back to Login
          </div>
          <h2 className="sign-in-title mb-3">Confirm Password</h2>
          <p>
            Please confirm your password to proceed.Password must be at least 8
            characters{" "}
          </p>
          <form onSubmit={handleSubmit} className="form">
            <div className="mt-3">
              <TextField
                fullWidth
                required
                label="New Password"
                name="password"
                type={passwordVisible ? "text" : "password"}
                value={inputs.password}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setPasswordVisible(!passwordVisible)}
                        edge="end"
                      >
                        {passwordVisible ? (
                          <VisibilityOffOutlinedIcon fontSize="small" />
                        ) : (
                          <VisibilityOutlinedIcon fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="mt-3">
              <TextField
                fullWidth
                required
                label="Confirm New password"
                name="new_password"
                type={newPasswordVisible ? "text" : "password"}
                value={inputs.new_password}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setNewPasswordVisible(!newPasswordVisible)
                        }
                        edge="end"
                      >
                        {newPasswordVisible ? (
                          <VisibilityOffOutlinedIcon fontSize="small" />
                        ) : (
                          <VisibilityOutlinedIcon fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div className="forgot-password-container mt-2"></div>
            <Button
              type="submit"
              className="mui-button"
              disabled={isLoading}
              variant="contained"
              fullWidth
            >
              {isLoading ? "loading..." : "Reset Password"}
            </Button>
          </form>
        </div>
      </div>
      <div className="logoContainer">
        <div className="logoContent">
          <img src={Logo} alt="new" className="logoImage" />
          <h2 className="logoTitle">Welcome, Admin</h2>
          <p>Manage your community and users effectively.</p>
        </div>
      </div>
    </div>
  );
}
